import script from "./CostingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CostingPage.vue?vue&type=script&setup=true&lang=js"

import "./CostingPage.vue?vue&type=style&index=0&id=ebd2e9ee&lang=scss&scoped=true"
import "./CostingPage.vue?vue&type=style&index=1&id=ebd2e9ee&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebd2e9ee"]])

export default __exports__